import { Group, Text } from "@mantine/core"
import type { ReactNode } from "react"

export function PageToolbar({ children, actions }: { children: ReactNode; actions?: ReactNode }) {
  return (
    <Group className="page-toolbar" justify="space-between" align="center" gap="md">
      <Text c="dimmed" size="sm">
        {children}
      </Text>
      {actions ? <Group gap="xs">{actions}</Group> : null}
    </Group>
  )
}
